import React from "react";
import "./GalleryPage.css";
import Gallery from "../components/Gallery";
import ImageSlider from "../components/ImageSlider";
import { SliderImages } from "../data/SliderImages";
import SEO from "../components/SEO";

export default function GalleryPage() {
    const slides = SliderImages;

    const containerStyles = {
        width: "100%",
        maxWidth: "1440px",
        height: "600px",
        margin: "0 auto 50px",
    };

    return (
        <>
            <SEO
                title="Gallery | MICO Pool Design and Consulting"
                description="View featured 3D pool, patio, kitchen, and backyard design concepts from MICO Pool Design and Consulting."
            />
            <div className="gallery-page">
                <h1 className="gallery-page-header">GALLERY</h1>
            </div>
            <div>
                <h1 className="gallery-head">FEATURED MODEL</h1>
            </div>
            <div style={containerStyles}>
                <ImageSlider slides={slides} />
            </div>
            <Gallery />
        </>
    );
}
